<template>
    <div class="manufacturer-arrows-container">
        <CommonComponentsSVGCommonBlueUpArrow class="solution-arrow-up" />
        <div class="manufacturer-part-flex">
            <div v-for="(item, index) in arrowsList" :key="index" class="topic">
                <CommonComponentsSolutionsManufacturerReuseTitle v-if="reuseTitle" :union-title="item" />
                <CommonComponentsUnionTitleWithNumber v-else :union-title="item" />

                <div v-if="item.videos" class="manufacturer-arrows-video-text">
                    <div
                        v-for="(videoItem, videoIndex) in item.videos"
                        :key="videoIndex"
                        class="manufacturer-arrows-video"
                    >
                        <CommonComponentsVideoPlayer
                            v-if="videoItem.path"
                            :class="['video', { 'video-click': videoItem.click ?? false }]"
                            @click="videoItem.click"
                            :sources="[
                                {
                                    src: videoItem.path,
                                    type: 'video/mp4',
                                },
                            ]"
                            :poster="videoItem.poster"
                        />
                        <img
                            v-else-if="videoItem.poster"
                            :class="['image', { 'image-click': videoItem.click ?? false }]"
                            @click="videoItem.click"
                            :src="videoItem.poster"
                        />
                        <!-- manufacturer 绿色卡片 -->
                        <div v-else class="manufacturer-arrows-card">
                            <CommonComponentsSolutionsManufacturerReuseVs />
                        </div>
                        <!--  v-if="item.describe && typeof item.describe == 'object'" 
                        :class="`describe-${videoIndex}`"
                    -->
                        <template v-if="typeof item.describe == 'object'">
                            <div class="text" v-if="item.describe[videoIndex]">
                                {{ $t(item.describe[videoIndex]) }}
                            </div>
                        </template>
                        <template v-else-if="item.describe">
                            <div class="text">
                                {{ $t(item.describe) }}
                            </div>
                        </template>
                        <template v-if="typeof item.subDescribe == 'object'">
                            <div class="text subText" v-if="item.subDescribe[videoIndex]">
                                {{ $t(item.subDescribe[videoIndex]) }}
                            </div>
                        </template>
                        <template v-else-if="item.subDescribe">
                            <div class="text subText">
                                {{ $t(item.subDescribe) }}
                            </div>
                        </template>

                        <div v-if="item.rightText" class="right-text">
                            <CommonComponentsTextWithCheckIcon
                                class="right-text-item"
                                v-for="(itemtext, index) in item.rightText"
                                :key="index"
                            >
                                <span class="fabric-text-scroll" v-html="$t(itemtext)" />
                            </CommonComponentsTextWithCheckIcon>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    defineProps<{
        arrowsList: Array<ArrowsListItem>;
        reuseTitle?: boolean;
    }>();

    // addToVideoElmt('.video');

    onMounted(() => {
        addTextScrollLine('.manufacturer-arrows-container .text');
        addSlideInUp('.manufacturer-arrows-container .solution-arrow-up');
        addSlideInDown('.manufacturer-arrows-container .solution-arrow-down');
        addFadeIn('.vsTitle');
    });
</script>

<style lang="less" scoped>
    .manufacturer-arrows-container {
        display: flex;
        flex-direction: column;
        // width: 100%;
        font-family: Montserrat, 'HarmonyOS Sans SC';

        .solution-arrow-up {
            margin: .convert(100px) [ @vw] 0;
            height: .convert(194px) [ @vw];
            @media (max-width: @screen-mobile-width) {
                margin-top: 40px;
                margin-bottom: 0px;
                height: 50px;
            }
        }

        // .two {
        //     // transform: translateY(.convert(-20px)[ @vw]);
        // }
        .topic {
            @media (max-width: @screen-mobile-width) {
                margin-top: .convert(20px) [ @vw-mobile] !important; //10px;
            }
        }

        .manufacturer-part-flex {
            display: flex;
            flex-direction: column;
            gap: .convert(100px) [ @vw];
            @media (max-width: @screen-mobile-width) {
                gap: .convert(40px) [ @vw];
            }
            .manufacturer-arrows-card {
                display: flex;
                flex-direction: column;
                justify-content: center;
                // gap: .convert(20px) [ @vw];
                // margin-top: .convert(40px) [ @vw];
                &:not(:last-child) {
                    // margin-bottom: .convert(100px) [ @vw];
                }

                @media (max-width: @screen-mobile-width) {
                    flex-direction: column;
                }
                .vsTitle {
                    display: flex;
                    justify-content: center;
                    margin-bottom: .convert(40px) [ @vw];
                    font-size: .convert(@font-size-title-xs) [ @vw]; //36px
                    font-weight: .convert(400px) [ @vw];
                }
            }
            .manufacturer-arrows-video {
                color: #fff;
                font-size: .convert(@font-size-title-xs) [ @vw];
                display: flex;
                flex-direction: column;
                justify-content: center;
                margin-top: .convert(40px) [ @vw];
                font-family: 'HarmonyOS Sans SC';
                .video {
                    // height: .convert(675px) [ @vw];
                    // @media (max-width: @screen-mobile-width) {
                    //     height: .convert(193px) [ @vw-mobile] !important;
                    // }
                    &.video-click {
                        cursor: pointer;
                    }
                }

                .image {
                    width: 100%;
                    @media (max-width: @screen-mobile-width) {
                        width: 100%;
                    }
                    &.image-click {
                        cursor: pointer;
                    }
                }

                &:not(:last-child) {
                    margin: .convert(40px) [ @vw] 0 .convert(100px) [ @vw] 0;
                }

                .video-0,
                .video-1 {
                    // height: .convert(675px) [ @vw];
                    // margin: 0 auto;
                    // @media (max-width: @screen-mobile-width) {
                    //     height: .convert(172px) [ @vw-mobile] !important;
                    //     // margin:0.convert(15px)[  @vw-mobile] ;
                    // }
                }
                .video-0 {
                    // margin-bottom: ;
                }
                .text {
                    text-align: center;
                    margin-top: .convert(20px) [ @vw];
                    font-size: .convert(@font-size-xl) [ @vw]; //24px
                    @media (max-width: @screen-mobile-width) {
                        font-size: .convert(@font-size-xm) [ @vw-mobile]; //12px
                        opacity: 0.6;
                        margin-top: .convert(10px) [ @vw-mobile];
                    }
                    &.subText {
                        margin-top: .convert(10px) [ @vw];
                        font-size: .convert(@font-size-lg) [ @vw]; //24px
                        color: #fff;
                        opacity: 0.6;
                    }
                }
                .right-text {
                    margin-left: .convert(80px) [ @vw];
                    margin-top: .convert(27px) [ @vw];
                    display: flex;
                    flex-direction: column;
                    gap: .convert(21px) [ @vw];
                    @media (max-width: @screen-mobile-width) {
                        margin-top: .convert(11px) [ @vw-mobile];
                        margin-left: .convert(0px) [ @vw-mobile];
                        gap: .convert(12px) [ @vw-mobile];
                    }

                    :deep(.text-with-check-icon-container) {
                        @media (max-width: @screen-mobile-width) {
                            font-size: .convert(12px) [ @vw-mobile];
                        }
                    }
                }
            }
        }
    }
</style>
